





















































import { Vue, Component, Prop } from 'vue-property-decorator';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  ColumnApi,
  GridReadyEvent,
  RowSelectedEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { Funcionalidades } from '@/config/funcionalidades';
import { actionsEvent } from '@/setup';
import {
  codigoAccionesMenuItem as cami,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import MenuItem from '@/components/MenuItem.vue';
import store from '@/store';
import AsignacionClienteGpsModal from '@/pantallas/AsignacionClienteGps/AsignacionClienteGpsModal.vue';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { LoadingService } from '@/services/loadingService';
import config from '@/config/index';
import { Row } from 'read-excel-file';

@Component({ components: { AgGridVue, MenuItem, AsignacionClienteGpsModal } })
export default class AsignacionClienteGps extends Vue {
  // States ##################################################

  // Vars globales
  $snotify: any;

  // instancia para llamar al backend
  axiosPy: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  axiosPyAws: AxiosVue = new AxiosVue(ServicioProxy.MetabaseAws);

  // vars asociadas al perfilamiento
  readonly codigoAccionesMenuItem = Object.values(cami);
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.AsignacionClienteGps;
  accionAsociarGps: PermisoAccion = {
    accionCodigo: 34,
    visible: false,
  };
  accionesTotales: PermisoAccion[] = [this.accionAsociarGps];

  searchGpsTF: string = '';
  openModalAssign: boolean = false;
  loadingService = new LoadingService();

  // vars asociados a la grilla
  gridOptions: GridOptions;
  gridApi: GridApi;
  columnApi: ColumnApi;
  editedGps: any = [];

  // Watchs ##################################################

  // Functions ###############################################

  // El constructor hará la carga inicial de la grilla, aplicando la config en la variable gridOptions
  constructor() {
    super();

    // Se agrega evento escucha cuando se presione el botón "Asociar Gps", gatillando la función "handleAssociateGps"
    actionsEvent.onAsociarGps(this.handleAssociateGps);

    // Se obtiene el perfilamiento del usuario - modulo
    let funcionalidad = this.funcionalidad;
    let codigoAccionesMenuItem = Object.values(cami);

    // Configuración de la grilla
    this.gridOptions = {
      // Columnas
      columnDefs: [
        {
          headerName: '',
          field: 'checked',
          width: 70,
          minWidth: 70,
          maxWidth: 70,
          pinned: 'left',
          checkboxSelection: true,
          suppressMenu: true,
          filter: false,
          suppressMovable: true,
          sortable: false,
          resizable: false,
          lockVisible: true,
          cellStyle: { textAlign: 'center' },
        },
        {
          headerName: 'Id',
          field: 'id',
          sortable: true,
          resizable: true,
          minWidth: 80,
          lockPinned: true,
          hide: true,
        },
        {
          headerName: 'Imei',
          field: 'imei',
          sortable: true,
          resizable: true,
          minWidth: 80,
          lockPinned: true,
        },
        {
          headerName: 'Número de serie',
          field: 'numeroserie',
          sortable: true,
          resizable: true,
          minWidth: 80,
          lockPinned: true,
        },
        {
          headerName: 'Patente',
          field: 'patente',
          sortable: true,
          resizable: true,
          minWidth: 80,
          lockPinned: true,
        },
        {
          headerName: 'Referencia',
          field: 'referencia',
          sortable: true,
          resizable: true,
          minWidth: 80,
          lockPinned: true,
        },
        // {
        //   headerName: 'Acciones',
        //   width: 120,
        //   minWidth: 120,
        //   sortable: false,
        //   resizable: false,
        //   filter: false,
        //   enablePivot: false,
        //   field: 'id',
        //   cellRendererFramework: MenuItem,
        //   cellRendererParams: (params: any) => {
        //     return {
        //       funcionalidad,
        //       codigoAccionesMenuItem,
        //       acciones: this.accionesTotales,
        //       usuario: store.state.user,
        //       data: params.data,
        //     };
        //   },
        //   colId: 'params',
        //   rowDrag: false,
        //   pinned: 'right',
        //   lockVisible: true,
        //   suppressMovable: true,
        //   getQuickFilterText: () => '',
        // },
      ],
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 50,
      cacheBlockSize: 10000,
      paginationAutoPageSize: false,
      onGridSizeChanged: event => {
        event.api.sizeColumnsToFit();
      },
      suppressRowClickSelection: true,
      suppressCellSelection: false,
      onRowSelected: this.onSelectedGps,
      // Con la prop onGridReady, se llamará a la función onGridReady cuando la grilla esté montada en el DOM, para cargar la data inicial
      onGridReady: this.onGridReady,
      suppressCopyRowsToClipboard: true,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      blockLoadDebounceMillis: 350,
      columnTypes: {},
      suppressCsvExport: false,
      suppressExcelExport: true,
    };
  }

  // Función que se llama cuando la grilla está totalmente montada en el DOM
  onGridReady(params: GridReadyEvent) {
    // variables para acceder facilmente a los props de la grilla
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    // Se inicializa la grilla con una lista vacia (para evitar que la grilla inicie con un loading)
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');

    // Se llama al servicio para obtener los gps y mostrarlo en la grilla
    this.getGps();
  }

  // Funcion para hacer visible el botón de asociar gps cuando se seleccione 1 o más filas
  onSelectedGps(event: RowSelectedEvent) {
    let selectedRows = this.gridApi.getSelectedRows();
    if (selectedRows.length > 0) {
      this.accionAsociarGps.visible = true;
    } else {
      this.accionAsociarGps.visible = false;
    }
  }

  // Función para buscar el texto ingresado en todas las columnas de la grilla
  handleSearchGps() {
    this.gridApi.setQuickFilter(this.searchGpsTF);
    this.gridApi.setDomLayout('autoHeight');
  }

  // Funcion para hacer visible el botón de asociar gps cuando se seleccione 1 o más filas
  handleSelectedGps(event: RowSelectedEvent) {
    let selectedRows = this.gridApi.getSelectedRows();
    if (selectedRows.length > 0) {
      this.accionAsociarGps.visible = true;
    } else {
      this.accionAsociarGps.visible = false;
    }
  }

  // Función que abre el modal de asociar Gps cuando se presione el botón
  handleAssociateGps(params: ICellRendererParams) {
    // Se abre el modal para asociar cliente - gps
    this.editedGps = this.gridApi.getSelectedRows();
    this.openModalAssign = true;
  }

  // Función para obtener los gps del cliente
  async getGps() {
    this.loadingService.showLoading();

    await this.axiosPyAws.http
      .post('Metabase/PostgenericA/gps/getGpsByClient', {
        clientId: config.getClienteSesion(),
      })
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          // le paso la data a la grilla
          this.gridApi.setRowData(response.data.data);
        } else {
          this.$snotify.error(response.data.MENSAJE_RESPUESTA);
        }
      })
      .catch((error: any) => {})
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  // Función de escucha cuando se cierre el modal:
  handleCloseModal() {
    this.openModalAssign = false;
  }

  // Función para guardar los cambios de asignación del modal
  async handleSaveAssign(selected: { clientSelected: any; gpsList: any }) {
    this.loadingService.showLoading();
    console.log(selected);
    let lstgpsid = selected.gpsList.map((x: any) => x.id);
    let body = {
      clientidAssign: selected.clientSelected.id,
      listagpsid: lstgpsid,
      userid: this.getUserID(),
    };
    await this.axiosPyAws.http
      .post('Metabase/PostgenericA/gps/reassignGps', body)
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.$snotify.success(response.data.MENSAJE_RESPUESTA);
          // Se cierra el modal si todo salió ok
          this.accionAsociarGps.visible = false;
          this.handleCloseModal();
        } else {
          this.$snotify.error(response.data.MENSAJE_RESPUESTA);
        }
      })
      .catch((response: any) => {})
      .finally(() => {
        this.loadingService.hideLoading();
        // Se actualiza la grilla para ver nuevos cambios
        this.getGps();
      });
  }

  // Función para obtener el id del usuario en sesión
  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }
}
